import { Component, EventEmitter, inject, Output } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth.service';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  standalone: true,
  selector: 'app-social-login-buttons',
  imports: [CommonModule, MatButtonModule, MatIconModule],
  template: `
    <div class="flex flex-col gap-3 mt-3">
      <button mat-raised-button color="primary" class="w-full py-2 font-semibold tracking-wide" (click)="login('google')"> Continuar con Google</button>
      <button mat-raised-button color="primary" class="w-full py-2 font-semibold tracking-wide" (click)="login('facebook')"> Continuar con Facebook</button>

      <p *ngIf="error" class="text-red-600 text-sm text-center">{{ error }}</p>
    </div>
  `
})
export class SocialLoginButtonsComponent {
  private authService = inject(AuthService);
  private router = inject(Router);

  error = '';
  @Output() success = new EventEmitter<void>();

  login(provider: 'google' | 'facebook') {
    console.log('login', provider);
    this.error = '';
    const loginMethod = provider === 'google'
      ? this.authService.loginWithGoogle()
      : this.authService.loginWithFacebook();

      loginMethod.then(async result => {
        const email = result.user?.email;
        if (!email) {
          this.error = 'No se pudo obtener el email del proveedor.';
          return;
        }
    
        const methods = await this.authService.getSignInMethods(email);
        if (methods.includes('password')) {
          this.error = 'Este email ya está registrado con una contraseña. Iniciá sesión con email y contraseña.';
          this.authService.logout();
          return;
        }
    
        this.success.emit(); // login válido
      })
      .catch(err => {
        this.error = this.traducirError(err.code || err.message);
      });
  }

  traducirError(code: string): string {
    switch (code) {
      case 'auth/invalid-email':
        return 'El email ingresado no es válido.';
      case 'auth/user-not-found':
        return 'No existe una cuenta con ese email.';
      case 'auth/popup-closed-by-user':
        return 'El inicio fue cancelado.';
      case 'auth/account-exists-with-different-credential':
        return 'Ya existe una cuenta con ese email usando otro método.';
      case 'auth/invalid-credential':
        return 'El email o la contraseña son incorrectos.';
      case 'auth/invalid-verification-code':
        return 'El código de verificación no es válido.';
      case 'auth/invalid-verification-id':
        return 'El ID de verificación no es válido.';
      case 'auth/invalid-phone-number':
      default:
        return 'Ocurrió un error. Intentá nuevamente.';
    }
  }
}
